import type { PropsWithChildren } from 'react'
import * as React from 'react'
import MessagingLabel, { type MessagingLabelVariant } from './MessagingLabel'

type Variant = 'positive' | 'speed' | 'warning' | 'critical1' | 'critical2'

const variantMap: Record<Variant, MessagingLabelVariant> = {
  positive: 'success',
  speed: 'urgency',
  warning: 'warning',
  critical1: 'critical-low',
  critical2: 'critical-high',
}

interface Props {
  variant: Variant
  className?: string
  icon?: React.ReactNode
  endIcon?: React.ReactNode
}

const UrgencyLabel = React.forwardRef<HTMLSpanElement, PropsWithChildren<Props>>((props, ref) => {
  const { variant, children, icon, endIcon, ...rest } = props

  return <MessagingLabel
    {...rest}
    ref={ref}
    variant={variantMap[variant]}
    startIcon={icon}
    endIcon={endIcon}
  >
    {children}
  </MessagingLabel>
})

UrgencyLabel.displayName = 'UrgencyLabel'

export default UrgencyLabel
